import { render, staticRenderFns } from "./IconBeakerSolid.vue?vue&type=template&id=95f77776"
import script from "./IconBeakerSolid.vue?vue&type=script&lang=js"
export * from "./IconBeakerSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports